'use client';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import Footer from '@/components/layout/Footer';
import { theme } from '@/theme';
import Header from '@/components/layout/Header';
import { GeistSans } from 'geist/font/sans';
import { GeistMono } from 'geist/font/mono';
import { AuthProvider } from '@/contexts/AuthContext';
import { PointsProvider } from '@/contexts/PointsContext';
import { ReferralProvider } from '@/contexts/ReferralContext';
import SessionHandler from '@/components/layout/SessionHandler';
import AuthDialogHandler from '@/components/auth/AuthDialogHandler';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import { Suspense } from 'react';

const geistSans = GeistSans;
const geistMono = GeistMono;

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en">
      <body className={`${geistSans.variable} ${geistMono.variable} antialiased`}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ErrorBoundary>
            <AuthProvider>
              <PointsProvider>
                <Suspense fallback={null}>
                  <ReferralProvider>
                    <Header />
                    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                      {children}
                      <Footer />
                    </Box>
                    <SessionHandler />
                    <AuthDialogHandler />
                  </ReferralProvider>
                </Suspense>
              </PointsProvider>
            </AuthProvider>
          </ErrorBoundary>
        </ThemeProvider>
      </body>
    </html>
  );
}
